import './input.scss';

import {
    faCheckCircle as faSolidCheckCircle,
    faCircleNotch,
    faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { BarcodeReader } from '@skinsoft/ui';
import { BFormInput } from 'bootstrap-vue';
import { defineComponent } from 'vue';

export enum ValidationStates {
    ERROR = 'error',
    PENDING = 'pending',
    SUCCESS = 'success',
    VALIDATING = 'validating',
}

export const Input = defineComponent({
    components: {
        sBarcodeReader: BarcodeReader,
    },
    props: {
        // `active`: used to know which input should mount the barcode reader
        active: { type: Boolean },
        barcodeSensitive: { type: Boolean },
        defaultValue: { type: String, default: null },
        label: { type: String, default: null },
        validationState: { type: String },
    },
    template: require('./input.html'),
    data() {
        return {
            validationIcons: {
                [ValidationStates.PENDING]: faCircleNotch,
                [ValidationStates.ERROR]: faTimesCircle,
                [ValidationStates.SUCCESS]: faSolidCheckCircle,
                [ValidationStates.VALIDATING]: faCircleNotch,
            },
            input: null as any,
            ValidationStates,
        }
    },
    computed: {
        value() {
            return (this.$refs.input as BFormInput).value;
        },
    },
    created() {
        this.input = this.defaultValue;
    },
    methods: {
        isValidationState(validationState: ValidationStates) {
            return this.validationState === validationState;
        },
        onBarcodeReaderInput(input) {
            this.input = input;
        },
        blur() {
            // @ts-ignore
            (this.$refs.input as BFormInput).$el.blur();
        },
        focus() {
            // @ts-ignore
            (this.$refs.input as BFormInput).$el.focus();
        },
        select() {
            // @ts-ignore
            (this.$refs.input as BFormInput).$el.select();
        },
        write(value: string) {
            this.input = value;
        },
        clear() {
            this.input = null as any;
        },
        onClick() {
            this.$emit('click')
        },
    },
    watch: {
        input: {
            handler(value) {
                this.$emit('change', value);
            },
            immediate: false,
        },
    },
})
